import axios from "axios";

export default {
    async DigitalDriverLicenseReport(data) {
        const response = await axios.post("/api/hroperations/digitaldriverlicensereport", data);
        return response;
    },
};
